import { render, staticRenderFns } from "./QuestionSearch.vue?vue&type=template&id=0a20b2c9&scoped=true"
import script from "./QuestionSearch.ts?vue&type=script&lang=ts&external"
export * from "./QuestionSearch.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionSearch.vue?vue&type=style&index=0&id=0a20b2c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20b2c9",
  null
  
)

export default component.exports